import { memo } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiOutlineClose } from 'react-icons/ai'
import { SummaryReceiptRow } from '../constants/Column'
import { OrderReceipt } from "./types"

const RemoveUnusedReceiptEditor = memo(({ props } : {
  props: EditorProps<OrderReceipt, SummaryReceiptRow>
}) => {
  const { onClose, onRowChange, row } = props

  return <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      updatedRow._deleted = true
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={'คำเตือนเนื่องจากมีการลบรายการ Receipt ที่ไม่ใช้แล้ว'}
    maxWidth='max-w-lg'
    >
    <div className='flex items-center gap-3'>
      <AiOutlineClose size={50} className='text-red-500 basis-1/6 ' />
      <div className="space-y-3 ">
        <h6>{'คุณกำลังจะลบรายการ Receipt ที่ไม่ใช้แล้ว ดังนี้'}</h6>
        <h6 className={`font-bold text-red-500`}>Batch No : {row.batchLotNo}</h6>
        <h6>ยืนยันหรือไม่ ?</h6>
      </div>
    </div>
  </Modal>
})

export default RemoveUnusedReceiptEditor